<div class="device-details-styles mat-typography">
  <ng-container *ngIf="loaded; else showNoDeviceDetails">
    <div modal-close class="close-button-container">
      <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!data.selectedDevice; else selectedDevice">
      <div class="device-details-dialog-title">
        <adp-label labelKey="DeviceDetails_Modal_Title"></adp-label>
      </div>
      <div class="device-details-dialog-subtitle">
        <adp-label labelKey="DeviceDetails_Modal_Subtitle"></adp-label>
      </div>
    </ng-container>
    <ng-template #selectedDevice>
      <div class="device-details-dialog-subtitle" style="padding-bottom: 0px;">{{data.selectedDevice.deviceTypeName}}</div>
      <div class="device-details-dialog-title" style="padding-bottom: 20px;">{{data.selectedDevice.displayName}}</div>
    </ng-template>

    <mat-dialog-content class="device-details-dialog-body">
      <form [formGroup]="form">
        <div class="device-details-dynamic-form-container">
          <div class="device-details-input" *ngIf="data.formFields.includes('buyType')" style="padding-bottom: 15px !important;">
            <adp-label labelKey="DeviceDetails_Modal_BuyType_Label"></adp-label>
            <mat-radio-group class="radio-group radio-group-container" formControlName="buyType" (change)="onBuyTypeChange()">
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="yes">Yes</mat-radio-button>
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <!-- Device Types -->
          <div class="device-details-input" *ngIf="data.formFields.includes('deviceType')">
            <adp-select class="w-100" *ngIf="selectableDeviceTypes.length > 0"
              (selectionChange)="onDeviceChange()" [resourceData]="getResource('DeviceType')"
              formControlName="deviceType" [listItems]="selectableDeviceTypes"></adp-select>
          </div>
          <!-- Make -->

          <div ifSettingFalse="DeviceDetails_Modal_Makes_Autocomplete_Enabled" class="device-details-input" *ngIf="data.formFields.includes('make')">
            <adp-select class="w-100" 
              (selectionChange)="onDeviceChange()" [resourceData]="getResource('Make')"
              formControlName="make" [listItems]="makes"></adp-select>
          </div>
          <!-- Make -->
          <div ifSettingTrue="DeviceDetails_Modal_Makes_Autocomplete_Enabled" class="device-details-input" *ngIf="data.formFields.includes('make')">

            <adp-autocomplete [autofill]="true" class="w-100"
              (focusout)="onDeviceChange()"  [listItems]="makes"
              [filteredOptions]="filterMakes" [resourceData]="getResource('Make')" formControlName="make">
            </adp-autocomplete>
          </div>
          <!-- Model -->
          <div class="device-details-input hide-wrapper" *ngIf="data.formFields.includes('model')">
            <adp-input matInput class="w-100" (blur)="onDeviceChange()"
              formControlName="model" [resourceData]="getResource('Model')"></adp-input>
            <mat-error *ngIf="form.get('model')?.hasError('invalidModelError')" class="custom-error">
              {{form.get('model')?.getError('invalidModelError')}}</mat-error>
          </div>
          <div class="device-details-input hide-wrapper hide-wrapper-p" *ngIf="data.formFields.includes('purchasePrice')">
            <adp-input matInput class="w-100" (blur)="onPurchasePriceChange()" (click)="onPPClick()" (keypress)="onPPKeyPress($event)"
              formControlName="purchasePrice" [resourceData]="getResource('PurchasePrice')"></adp-input>
            <mat-error *ngIf="form.get('purchasePrice')?.hasError('invalidPriceError')" class="custom-error">
              {{form.get('purchasePrice')?.getError('invalidPriceError')}}</mat-error>
          </div>
          <div class="device-details-input hide-wrapper" *ngIf="data.formFields.includes('purchaseDate')" style="margin-left: -3px;">
            <adp-date matInput class="w-100" (selectedDate)="onDateChange()" (blur)="onDateChange()"
              formControlName="purchaseDate" [resourceData]="getResource('PurchaseDate')"></adp-date>
              <mat-error *ngIf="form.get('purchaseDate')?.hasError('invalidDateError')" class="custom-error">
                {{form.get('purchaseDate')?.getError('invalidDateError')}}</mat-error>
              <mat-error *ngIf="form.get('purchaseDate')?.hasError('futureDateError')" class="custom-error">
                {{form.get('purchaseDate')?.getError('futureDateError')}}</mat-error>
                <mat-error *ngIf="form.get('purchaseDate')?.hasError('minDateError')" class="custom-error">
                  {{form.get('purchaseDate')?.getError('minDateError')}}</mat-error>
          </div>
          <div class="device-details-input" *ngIf="data.formFields.includes('serialNumber')">
            <adp-input matInput class="w-100" (change)="onDeviceChange()"
              formControlName="serialNumber" [resourceData]="getResource('SerialNumber')"></adp-input>
          </div>
          <!-- Nickname -->
          <div class="device-details-input" *ngIf="data.formFields.includes('nickName')">
            <adp-input matInput class="w-100" (change)="onDeviceChange()"
              formControlName="nickName" [resourceData]="getResource('Nickname')"></adp-input>
          </div>
          <br />
        </div>
      </form>
    </mat-dialog-content>
    <div modal-footer style="min-width:100%;">
      <div class="row reverse-wrap">
        <div class="col-md-6">
          <button mat-stroked-button color="primary" [mat-dialog-close]="false" style="border: none;">
            <adp-label labelKey="Global_Button_Cancel"></adp-label></button>
        </div>
        <div class="col-md-6">
          <button mat-flat-button color="accent" [mat-dialog-close]="true" [disabled]="!isValidDevice">
            <adp-label *ngIf="!data.selectedDevice" labelKey="Global_Button_Next"></adp-label>
            <adp-label *ngIf="data.selectedDevice" labelKey="DeviceDetails_Modal_AddDevice_Button_Label"></adp-label>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #showNoDeviceDetails>
    <div class="device-details-loading-container" *ngIf="!loaded && !hasError">
      <div class="device-details-assurant-loader">
        <div class="device-details-progress-line"></div>
      </div>
      <div class="mfe-caption-1">{{loadingDeviceDetailsMessage}}</div>
    </div>
    <div *ngIf="hasError">
      <div class="device-details-error">
        <div class="device-details-icon-container">
          <mat-icon class="device-details-warning-icon" svgIcon="error-warning"></mat-icon>
        </div>
        <div>
          <div class="error-header">{{ errorHeading }}</div>
          <div class="error-body">{{ errorMessage }}</div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
